import useToggle from '@/common/hooks/useToggle';
import { CustomizeMap } from '@/constants/customizeMap';
import { websiteEnv } from '@/constants/website-env';
import { getFirstPart } from '@/util/getFirstPart';
import clsx from 'clsx';
import { Fragment } from 'react';

const ProductOptions = props => {
  const { options = [], custom_info, classes = {}, showSizeExpandBtn = true } = props;

  const [showCustomOptions, toggleShowCustomOptions] = useToggle(false);

  const custom_options =
    showCustomOptions || !showSizeExpandBtn
      ? custom_info?.map((item, index) => (
          <li
            key={index}
            className={classes.options}
          >
            {item.label} : {CustomizeMap[item.value] || item.value}
          </li>
        ))
      : null;

  const standardOptions = options.map(({ option_label, value_label, label, values }) => {
    const key = option_label && value_label ? `${option_label}${value_label}` : `${label}${values[0].label}`;

    let optionLabelPart = option_label ? getFirstPart(option_label) : getFirstPart(label);

    if (websiteEnv.isUnitedKingdom && optionLabelPart === 'Color') {
      optionLabelPart = 'Colour';
    }

    const optionLabelString = `${optionLabelPart} : `;

    const icon = showCustomOptions ? (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='11'
        height='6'
        fill='none'
        viewBox='0 0 11 6'
      >
        <path
          fill='#8B857D'
          d='M.5 5.5h2.07L5.5 2.57 8.43 5.5h2.07l-5-5z'
        />
      </svg>
    ) : (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='11'
        height='6'
        fill='none'
        viewBox='0 0 11 6'
        className='rotate-180'
      >
        <path
          fill='#8B857D'
          d='M.5 5.5h2.07L5.5 2.57 8.43 5.5h2.07l-5-5z'
        />
      </svg>
    );
    const isCustomizedSize = value_label === 'customized_size';

    if (isCustomizedSize) {
      if (!showSizeExpandBtn) {
        return (
          <Fragment key={key}>
            <li className={clsx(classes.options)}>Size Ordered:</li>
            {custom_options}
          </Fragment>
        );
      }

      return (
        <Fragment key={key}>
          <li className={clsx('flex items-center', classes.options, 'max-w-max cursor-pointer bg-f8f3ef pr-3')}>
            <span>{optionLabelString}</span>&nbsp;
            <div
              className='flex items-center'
              onClick={toggleShowCustomOptions}
            >
              <span>Custom</span>&nbsp;
              {icon}
            </div>
          </li>
          {custom_options}
        </Fragment>
      );
    }

    let valueLabel = value_label.replace(/-default/, '');

    if (websiteEnv.isUnitedKingdom && valueLabel === 'Multi Color') {
      valueLabel = 'Multicolour';
    }

    return (
      <Fragment key={key}>
        <li className={clsx('flex items-center', classes.options)}>
          <span>{optionLabelString}</span>&nbsp;
          <div>{valueLabel}</div>
        </li>
      </Fragment>
    );
  });

  if (options.length === 0) {
    return null;
  }

  return <ul>{standardOptions}</ul>;
};

export default ProductOptions;
